<span class="_content">
    <ng-content></ng-content>
</span>
<icms-icon *ngIf="icon"
           class="_icon"
           [icon]="icon"></icms-icon>
<div *ngIf="isBusy"
     class="_loader">
    <icms-loader [dfs]="'d:block'"></icms-loader>
</div>